/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in 
*                 part without express written permission of Honeywell Inc. 
*                 is prohibited.
*
* Name          : console-utility.ts
* 
* Project Title : Checkout
*  
* Description   : Initial version
* 
* Company       : Honeywell Technology Solutions , Hyderabad
* 
* @Author       : Madhu Gali - H175591
* 
* @Date         : Oct 07, 2019
*
* @Version      : Version 1.0
* 
******************************************************************************/
import { isDebugEnabled } from "./util";

export function logInfo(message?: string, ...args: any[]) {
    if (isDebugEnabled()) {
        console.log(message, args);
    }
}

export function logWarn(message?: string, ...args: any[]) {
    if (isDebugEnabled()) {
        console.warn(message, args);
    }
}

export function groupCollapsed(groupTitle?: string, ...optionalParams: any[]) {
    if (isDebugEnabled()) {
        console.groupCollapsed(groupTitle, optionalParams);
    }
}

export function groupEnd() {
    if (isDebugEnabled()) {
        console.groupEnd();
    }
}

export function logError(message?: string, ...args: any[]) {
    if (isDebugEnabled()) {
        console.error(message, args);
    }
}